module.exports = __webpack_public_path__ + "media/components/assets/sujung_16-b1b1b99d859c63d59fb3a78efeca4da7.png";